import styled from 'styled-components'
import { calculateResponsiveSize, mediaMax } from 'styles/media-queries'
import CloseIcon from 'icons/close.svg'

export const Content = styled.div`
  // width: ${calculateResponsiveSize(456)};
  width: auto;
  // height: ${calculateResponsiveSize(655)};
  height: auto;
  background: var(--WW-Blue, #0033a0);
  position: fixed;
  padding: ${calculateResponsiveSize(40)} ${calculateResponsiveSize(90)};
  display: flex;
  flex-direction: column;
  gap: ${calculateResponsiveSize(33)};
  left: 50%;
  top: 50dvh;
  transform: translate(-50%, -50%);
  ${mediaMax('mobile')} {
    display: none;
  }
`
export const Title = styled.div`
  color: var(--OWW-Warm-Gray-4, #fff);
  text-align: center;
  white-space: nowrap;

  font-family: 'Berthold Akzidenz Grotesk';
  font-size: ${calculateResponsiveSize(18)};
  font-style: normal;
  font-weight: 500;
  line-height: 130%;
  letter-spacing: ${calculateResponsiveSize(1.26)};
  text-transform: uppercase;
`

export const ImageWrapper = styled.div`
  line-height: 0;
  img {
    width: 100%;
  }
`

export const View = styled.a`
  display: flex;
  padding: ${calculateResponsiveSize(10)} ${calculateResponsiveSize(15)}
    ${calculateResponsiveSize(8)} ${calculateResponsiveSize(15)};
  justify-content: center;
  align-items: center;
  color: var(--WW-Blue, #0033a0);
  text-align: center;

  font-family: 'Berthold Akzidenz Grotesk';
  font-size: ${calculateResponsiveSize(20)};
  font-style: normal;
  font-weight: 500;
  line-height: 100%;
  letter-spacing: ${calculateResponsiveSize(1)};
  text-transform: uppercase;
  background: #fff;
  margin: 0 auto;
`

export const CloseButton = styled.button`
  width: ${calculateResponsiveSize(22)};
  height: ${calculateResponsiveSize(22)};
  -webkit-mask: url(${CloseIcon}) no-repeat;
  -webkit-mask-size: contain;
  background: #fff;
  display: flex;
  top: ${calculateResponsiveSize(18)};
  right: ${calculateResponsiveSize(18)};
  position: absolute;
  cursor: pointer;
  ${mediaMax('mobile')} {
  }
`
